import styled from '@emotion/styled';
import React from 'react';
import {EListEntryComponentProps} from 'webapp-lib/Components';
import {mixinFlexboxColumn} from 'webapp-lib/styling';

import i18n from '_/i18n';

import {PdfHighlight} from '../PdfHighlight.utils';

export const PdfHighlightItem = ({
  item,
  onClick,
  onContextMenu,
  onDoubleClick,
}: EListEntryComponentProps<PdfHighlight>): React.ReactElement => (
  <PdfHighlightWrapper
    role='button'
    onClick={onClick}
    onContextMenu={onContextMenu}
    onDoubleClick={onDoubleClick}
  >
    <PdfHighlightContent>
      <span>{item.content}</span>
    </PdfHighlightContent>
  </PdfHighlightWrapper>
);

export const PdfHighlightPageHeader = ({
  item,
}: EListEntryComponentProps<PdfHighlight>): React.ReactElement => (
  <PdfHighlightHeader className='header'>
    <span>
      {i18n.t('common:pdfViewer.highlights.pageNumber', {
        number: item.pageIndex + 1,
      })}
    </span>
  </PdfHighlightHeader>
);

const PdfHighlightWrapper = styled.div`
  ${mixinFlexboxColumn};
  gap: var(--gutter-little);
  color: var(--color-core-black);
  cursor: pointer;
  padding: var(--gutter-small);
  border-bottom: var(--regular-border-width) solid var(--color-core-grey);
`;

const PdfHighlightContent = styled.div`
  display: flex;
  align-items: center;
  gap: var(--gutter-little);
  font-size: var(--font-size-small);
`;

const PdfHighlightHeader = styled.div`
  display: flex;
  user-select: none;
  grid-template-rows: min-content auto;
  align-items: center;
  font-size: var(--font-size-tiny);

  padding: var(--gutter-tiny) var(--gutter-small) var(--gutter-tiny)
    var(--gutter-small);
  line-height: 14px;

  &.header {
    color: var(--color-core-primary);
    font-weight: var(--font-weight-paragraph-title);
    background-color: var(--color-core-cockpit-boxes);
  }
`;
